// Polyfill `crypto.randomUUID` for browsers in our supported range that ship
// `crypto.getRandomValues` but not `crypto.randomUUID` (e.g. Safari < 15.4,
// iOS < 15.4, Firefox < 95).
if (typeof window !== "undefined" && typeof crypto !== "undefined" && typeof crypto.randomUUID !== "function") {
  const byteToHex = Array.from({ length: 256 }, (_, i) => (i + 0x100).toString(16).slice(1));

  crypto.randomUUID = function randomUUID() {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    // RFC 4122 §4.4: set version (4) in byte 6 and variant (10xx) in byte 8.
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = Array.from(bytes, (byte) => byteToHex[byte]);
    return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10, 16).join("")}`;
  };
}

export {};
